var AfterPayPayment = (function ($, PaymentProviderBase, CheckoutSettings, PromiseUtil) {

    var AfterPayPayment = PaymentProviderBase.extend({

        type: 'afterpay',
        paymentOption: CheckoutSettings.PaymentOption.AfterPay,

		prepayment: function () {
            var afterpaySrc = CheckoutSettings.getBasketSettings().AfterpaySrc;
            var returnUrl = location.origin + location.pathname;

            this._createAfterpayOrder(returnUrl, afterpaySrc);

            // because of redirect, stop next pipeline processing
            return PromiseUtil.rejected({});
		},

		complete: function (data) {
            // noop, this method not in use
            return PromiseUtil.rejected({});
		},

		tryComplete: function (token) {
            return this._afterPayCreatePayment(token);
		}
	});

    return AfterPayPayment;
})($, PaymentProviderBase, CheckoutSettings, PromiseUtil);
